import { ROUTE_PATHS } from "../../common/enums/routing-enums";
import type { NavItem } from "./types";

export const sectionRoutePaths: Record<string, string[]> = {
  performance: [
    ROUTE_PATHS.PERFORMANCE_DASHBOARD,
    ROUTE_PATHS.PERFORMANCE_PLUS,
    ROUTE_PATHS.MONTHLY_Q,
    ROUTE_PATHS.EARNINGS_CALCULATOR,
    ROUTE_PATHS.MBI,
    ROUTE_PATHS.MBIMonthlyBonuses,
    ROUTE_PATHS.ONLINE_STATEMENTS,
    ROUTE_PATHS.LEADERSHIP_SEMINAR,
    ROUTE_PATHS.HAT,
    ROUTE_PATHS.FAA,
    ROUTE_PATHS.ANNUALQ,
    ROUTE_PATHS.FRONTLINE_Q,
    ROUTE_PATHS.TWO_TIME_CASH_INCENTIVE,
    ROUTE_PATHS.STRONG_START_INCENTIVE,
    ROUTE_PATHS.BRONZE_INCENTIVES,
    ROUTE_PATHS.CSI,
    ROUTE_PATHS.PPE,
    ROUTE_PATHS.MONTHLY_PGG,
    ROUTE_PATHS.QC_GROWTH,
    ROUTE_PATHS.ANNUAL_PGG,
    ROUTE_PATHS.PGG_GCR,
    ROUTE_PATHS.FGG,
    ROUTE_PATHS.HEALTH_WELLBEING,
    ROUTE_PATHS.VISION_BONUS,
    ROUTE_PATHS.LEADERSHIP_PLUS,
    ROUTE_PATHS.DIAMOND_BONUS,
    ROUTE_PATHS.PERFORMANCE_BONUS,
  ],
  "group-management": [
    ROUTE_PATHS.GROUP_MANAGEMENT_DASHBOARD,
    ROUTE_PATHS.LOS,
    ROUTE_PATHS.EDLOS,
    ROUTE_PATHS.EDLOS_DOWNLINE,
    ROUTE_PATHS.WATCHLIST,
    ROUTE_PATHS.CUSTOMER_LIST,
    ROUTE_PATHS.BRONZE_GROUP_TRACKING,
    ROUTE_PATHS.SOP_REPORT,
    ROUTE_PATHS.WHOS_NEW_ACTION_REPORT,
    ROUTE_PATHS.WHOS_CLOSE_ACTION_REPORT,
    ROUTE_PATHS.BIRTHDAYS_ACTION_REPORT,
    ROUTE_PATHS.RENEWALS,
    ROUTE_PATHS.NON_BONUSABLE_BV_ACTION_REPORT,
    ROUTE_PATHS.SSI_UPLINE_REPORT,
    ROUTE_PATHS.CVR,
    ROUTE_PATHS.IBO_ONBOARDING,
    ROUTE_PATHS.CBR,
    ROUTE_PATHS.SAQ_ACTION_REPORT,
  ],
  academy: [ROUTE_PATHS.ACADEMY_AUTH],
};

export const perfIncomeItems: NavItem[] = [
  {
    id: "dashboard",
    label: "Dashboard",
    entryPage: "dashboard",
    path: ROUTE_PATHS.PERFORMANCE_DASHBOARD,
    contentKey: "perfIncomeDashboardLink",
  },
  { id: "monthlyQ", label: "Monthly Q1/QV+", entryPage: "monthlyQ", path: ROUTE_PATHS.MONTHLY_Q },
  { id: "calculator", label: "Earnings Calculator", entryPage: "calculator", path: ROUTE_PATHS.EARNINGS_CALCULATOR },
  { id: "mbi", label: "My Business Income", entryPage: "mbi", path: ROUTE_PATHS.MBI },
  {
    id: "onlineStatements",
    label: "Online Statements",
    entryPage: "onlineStatements",
    path: ROUTE_PATHS.ONLINE_STATEMENTS,
  },
  { id: "lsi", label: "Leadership Trip Qualification", entryPage: "lsi", path: ROUTE_PATHS.LEADERSHIP_SEMINAR },
  { id: "hatGar", label: "HAT/GAR", entryPage: "hatGar", path: ROUTE_PATHS.HAT },
  { id: "faa", label: "FAA", entryPage: "faa", path: ROUTE_PATHS.FAA },
  { id: "annualQ", label: "Annual Q+", entryPage: "annualQ", path: ROUTE_PATHS.ANNUALQ },
  { id: "frontlineQ", label: "Frontline Q+", entryPage: "frontlineQ", path: ROUTE_PATHS.FRONTLINE_Q },
  { id: "ttci", label: "Two Time Cash Incentive+", entryPage: "ttci", path: ROUTE_PATHS.TWO_TIME_CASH_INCENTIVE },
];

export const groupMgmtNavItems: NavItem[] = [
  {
    id: "dashboard",
    label: "Action Center",
    entryPage: "dashboard",
    path: ROUTE_PATHS.GROUP_MANAGEMENT_DASHBOARD,
    contentKey: "groupManagementActionCenterLink",
  },
  {
    id: "los",
    label: "Line of Sponsorship (LOS)",
    entryPage: "los",
    path: ROUTE_PATHS.LOS,
    contentKey: "los",
  },
  {
    id: "edlos",
    label: "Emerald & Diamond LOS",
    entryPage: "edlos",
    path: ROUTE_PATHS.EDLOS,
    contentKey: "edlos",
  },
  { id: "watchlist", label: "Watchlist", entryPage: "watchlist", path: ROUTE_PATHS.WATCHLIST },
  {
    id: "customerList",
    label: "Customer Member List",
    entryPage: "customerList",
    path: ROUTE_PATHS.CUSTOMER_LIST,
    contentKey: "customerMemberList",
  },
];
